import type { ComponentType } from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { useAccountAlias } from "resources/account"
import { getRole } from "helpers/permissions/roles"

// Route gate for admin-only surfaces. Role lives outside enabledFeatures (it comes from
// global.selected.accountId / user.accounts), so withFeatureGate cannot cover it. Hiding the
// corresponding nav tab is presentation only, not a permission check: a non-admin who reaches
// the route directly is redirected to /home instead of seeing the admin-only content.
export default function withAdminGate<Props extends object>(WrappedComponent: ComponentType<Props>) {
  const ComponentWithAdminGate = (props: Props) => {
    const account = useAccountAlias()
    const role = useSelector(getRole)

    if (role === "admin") {
      return <WrappedComponent {...props} />
    }

    return <Navigate to={`/${account}/home`} replace />
  }

  ComponentWithAdminGate.displayName = `WithAdminGate(${WrappedComponent.displayName || WrappedComponent.name})`

  return ComponentWithAdminGate
}
